<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-checkbox-group
        v-model="Promo.promoTargetPushCart.boundary.boundaryType"
        style="width: 100%"
      >
        <template v-for="(formcheck, idx) in formCheck">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-checkbox :label="formcheck.value" class="mt-2">{{
                formcheck.label
              }}</el-checkbox>
            </el-col>
            <el-col :span="14">
              <el-form-item size="small" style="margin: 0">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="flex-wrap: wrap"
                >
                  <template v-for="(form, idx) in formcheck.form">
                    <el-col
                      :span="form.span"
                      style="margin-bottom: 18px"
                      :key="idx"
                    >
                      <el-input
                        v-if="
                          (form.type == 'text' ||
                            form.type == 'password' ||
                            form.type == 'number') &&
                          (formcheck.value === 'qty' ||
                            formcheck.value === 'value')
                        "
                        v-model="
                          Promo.promoTargetPushCart.boundary[formcheck.value][
                            form.id
                          ]
                        "
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formcheck.value)"
                      ></el-input>
                      <el-input
                        v-else-if="
                          form.type == 'text' ||
                          form.type == 'password' ||
                          form.type == 'number'
                        "
                        v-model="Promo.promoTargetPushCart.boundary[form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formcheck.value)"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="Promo.promoTargetPushCart.boundary[form.id]"
                        style="width: 100%"
                        :disabled="disabledField(formcheck.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                    {{ form.satuan }}
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-checkbox-group>
    </el-card>
  </el-row>
</template>

<script>
export default {
  props: ["Promo"],
  data() {
    return {};
  },
  computed: {
    formCheck() {
      return [
        {
          label: "Customer Class",
          value: "customerClass",
          form: [
            {
              type: "select",
              id: "customerClass",
              label: "",
              rules: [],
              data: [
                {
                  name: "Traditional Market",
                  value: "Traditional Market"
                },
                {
                  name: "Modern Market",
                  value: "Medern Market"
                },
              ],
            }
          ]
        },
        {
          label: "Customer Type",
          value: "customerType",
          form: [
            {
              type: "select",
              id: "customerType",
              label: "",
              rules: [],
              data: [
                {
                  name: "BIG GROSIR",
                  value: "BIG GROSIR"
                },
                {
                  name: "SEMI GROSIR",
                  value: "SEMI GROSIR"
                }
              ]
            }
          ]
        },
      ];
    }
  },
  methods: {
    disabledField(value) {
      return !this.Promo.promoTargetPushCart.boundary.boundaryType.includes(value)
    },
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
